import * as React from 'react';

import { useDeviceType } from '@cian/ui-kit';

import { PreviewImg } from '../../components/packages/PreviewImg';

export interface ICardAvatarContainerProps {
  imgUrl?: string | null;
  fullName?: string | null;
  isCircleImage?: boolean;
}

export function CardAvatarContainer({ imgUrl, fullName, isCircleImage }: ICardAvatarContainerProps) {
  const deviceType = useDeviceType();
  const firstLetter = fullName ? fullName[0].toUpperCase() : '?';

  const imageSize = deviceType === 'desktop' ? 64 : 56;

  return (
    <PreviewImg
      width={imageSize}
      url={imgUrl || ''}
      height={imageSize}
      firstLetter={firstLetter}
      circle={isCircleImage}
    />
  );
}
